import './style.scss';

class WorkflowFilter {
  #tagElements;
  #filterElements;
  #clickedOnFilter;

  constructor() {
    this.#tagElements = document.querySelectorAll('[data-filter="tags"]');
    this.#filterElements = document.querySelectorAll('[data-filter="item"]');
    this.#clickedOnFilter = [];
  }

  #convertToSlug(text) {
    return text
      .toLowerCase()
      .replaceAll(/[^\w ]+/g, '')
      .replaceAll(/ +/g, '-');
  }

  #addSlugs() {
    if (this.#tagElements.length > 0 && this.#filterElements.length > 0) {
      for (const item of this.#tagElements) {
        const slugValue = this.#convertToSlug(item.textContent);
        item.setAttribute('tag-name', slugValue);
      }

      for (const item of this.#filterElements) {
        const slugValue = this.#convertToSlug(item.textContent);
        item.closest('.w-dyn-item').setAttribute('card-name', slugValue);
      }
    }
  }

  #addListener() {
    if (this.#tagElements.length > 0) {
      for (const tag of this.#tagElements) {
        tag.addEventListener('click', (event) => {
          let targetElm = event.currentTarget;
          let tagName = targetElm.getAttribute('tag-name');
          let isActive = targetElm.getAttribute('is-active');
          let getCards = [];
          if (tagName === 'all') {
            this.#clickedOnFilter = [];
            targetElm.setAttribute('is-active', true);
            targetElm.classList.add('active-tag');
            this.#resetTags(targetElm);
          } else if (isActive === 'false') {
            targetElm.classList.add('active-tag');
            targetElm.setAttribute('is-active', true);
            this.#clickedOnFilter.push(tagName);
            if (this.#tagElements[0].classList.contains('active-tag'))
              this.#tagElements[0].classList.remove('active-tag');
          } else if (isActive === 'true') {
            targetElm.classList.remove('active-tag');
            targetElm.setAttribute('is-active', false);
            let index = this.#clickedOnFilter.indexOf(tagName);
            this.#clickedOnFilter.splice(index, 1);
          }

          if (this.#clickedOnFilter.length > 0) {
            for (const filter of this.#clickedOnFilter) {
              getCards.push(...document.querySelectorAll(`[card-name='${filter}']`));
            }
            this.#showAndHideCard(getCards, false);
          } else {
            this.#tagElements[0].setAttribute('is-active', true);
            this.#tagElements[0].classList.add('active-tag');
            this.#showAndHideCard(getCards, true);
          }
        });
      }
      // To activate default
      this.#tagElements[0].click();
    }
  }

  #showAndHideCard(filteredCards, reset) {
    let allCards = document.querySelectorAll('[card-name]');
    for (const card of allCards) {
      if (reset) {
        card.style.display = 'block';
      } else {
        card.style.display = filteredCards.includes(card) ? 'block' : 'none';
      }
    }
  }

  #resetTags(tagElm) {
    for (const tag of this.#tagElements) {
      if (tag !== tagElm && tag.classList.contains('active-tag')) {
        tag.classList.remove('active-tag');
        tag.setAttribute('is-active', false);
      }
    }
  }

  initialize() {
    this.#addSlugs();
    this.#addListener();
  }
}

(() => {
  if (globalThis.location.pathname === '/workflows') {
    const workflowFilter = new WorkflowFilter();

    workflowFilter.initialize();
  }
})();
